<template>
  <div>
    <h1>{{ $tc('word.newsletter', 2) }}</h1>
    <form method="post" @submit.prevent="filterObjects()" v-if="objectList">
      <div class="row">
        <div class="col-md-4 mb-3">
          <v-date-picker
            v-model="formData.start_date"
            label="Start Date"
            :translate-text="false"
          />
        </div>
        <div class="col-md-4 mb-3">
          <v-date-picker
            v-model="formData.end_date"
            label="End Date"
            :translate-text="false"
          />
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-end">
          <v-button
            type="submit"
            icon="filter"
            :text="`Filter (${objectList.length})`"
            :block="true"
            :translate-text="false"
          />
        </div>
      </div>
    </form>

    <v-loader v-if="loading" />
    <table class="table" v-else>
      <thead>
      <tr>
        <th>
          {{ $t('word.email') }}
          <v-button
            :icon="copied ? 'check' : 'copy'"
            style-type="link"
            :disabled="copied"
            size="xs"
            @click="copyEmailsToClipboard()"
          />
        </th>
        <th>{{ $t('word.timestamp') }}</th>
      </tr>
      </thead>
      <tr
        v-for="registration in objectList"
        :key="registration.timestamp">
        <td>{{registration.email}}</td>
        <td>{{stringToPrettyDateTime(registration.timestamp)}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { GenericListMixin } from '@/common/utils/mixins';
import Button from '@/common/components/Button.vue';
import DatePicker from '@/common/components/inputs/DatePicker.vue';
import Loader from '@/common/components/Loader.vue';
import { stringToPrettyDateTime, toFormattedDate } from '@/common/utils/formatting';

export default {
  name: 'NewsletterRegistrationList',
  components: {
    'v-button': Button,
    'v-date-picker': DatePicker,
    'v-loader': Loader,
  },
  data: () => ({
    apiPath: 'admin/newsletter-registrations/',
    copied: false,
    formData: {
      start_date: null,
      end_date: null,
    },
  }),
  methods: {
    stringToPrettyDateTime,
    getParams() {
      return {
        start_date: toFormattedDate(this.formData.start_date),
        end_date: toFormattedDate(this.formData.end_date),
      };
    },
    copyEmailsToClipboard() {
      const text = this.objectList.map((registration) => registration.email).join('\n');
      navigator.clipboard.writeText(text).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 1000);
      }, (err) => {
        console.error('Async: Could not copy text: ', err);
      });
    },
  },
  mixins: [
    GenericListMixin,
  ],
  created() {
    const now = new Date();
    this.formData.start_date = new Date(now.getFullYear(), 0, 1);
    this.formData.end_date = now;
  },
};
</script>
